import { NestedSelect } from "src/components/generics/nestedSelect/NestedSelect";
import { useTopBarSelect } from "./TopBarSelect.hook";

export const TopBarSelect = (): JSX.Element => {
    const { selected, elements, handleSelect } = useTopBarSelect();

    return <NestedSelect selected={selected} elements={elements} handleSelect={handleSelect} />;
};
